import { render, staticRenderFns } from "./system.vue?vue&type=template&id=6406c0a1&"
import script from "./system.vue?vue&type=script&lang=ts&"
export * from "./system.vue?vue&type=script&lang=ts&"
import style0 from "./system.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports